import { render, staticRenderFns } from "./TermsAndConditionsUae.vue?vue&type=template&id=1c2f92da&"
import script from "./TermsAndConditionsUae.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsUae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports